import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material'
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form'

type Option = {
	value: string
	label: string
}

type Props<T extends FieldValues> = {
	name: Path<T>
	label: string
	options: Option[]
	disabled?: boolean
	row?: boolean
	size?: 'small' | 'medium'
	fieldLabelPlacement?: 'row' | 'column'
}

/**
 * Radio Group component for react-hook-form
 */
export default function RHFRadioGroup<T extends FieldValues>({
	name,
	label,
	options,
	disabled = false,
	row = false,
	size = 'medium',
	fieldLabelPlacement = 'column',
	...rest
}: Props<T>) {
	const { control } = useFormContext<T>()

	return (
		<FormControl disabled={disabled}>
			<Stack
				direction={fieldLabelPlacement}
				alignItems={fieldLabelPlacement === 'row' ? 'center' : null}
				gap={fieldLabelPlacement === 'row' ? 2 : 0}
			>
				<FormLabel>{label}</FormLabel>
				<Controller
					name={name}
					control={control}
					render={({ field }) => (
						<RadioGroup {...field} row={row} {...rest}>
							{options.map((option) => (
								<FormControlLabel
									key={option.value}
									value={option.value}
									control={<Radio size={size} />}
									label={option.label}
								/>
							))}
						</RadioGroup>
					)}
				/>
			</Stack>
		</FormControl>
	)
}
